<script setup>
// Action-strip "Information" trigger + dialog for admin-authored rich text
// (tournaments / ladders / leagues). Renders NOTHING when there's no content,
// so the link only appears when information has been written. Designed to sit
// inside a `.tl-action-strip` (renders an `.as` button).
import {ref} from "vue";
import TlDialog from "~/components/TlDialog.vue";

defineProps({
  html: {
    type: String,
    default: null
  },
  title: {
    type: String,
    default: 'Information'
  }
});

const open = ref(false);
</script>

<template>
  <template v-if="html">
    <button type="button" class="as" @click="open = true">
      <v-icon size="17">mdi-information-outline</v-icon>
      Information
    </button>
    <tl-dialog v-model="open" :title="title" :max-width="640">
      <div class="written-content" v-html="html"/>
    </tl-dialog>
  </template>
</template>
